// extracted by mini-css-extract-plugin
export var documentation = "_ji-1";
export var menu = "_ji-0";